/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/token';
import '../../common/attribute';
import '../../common/user_attributes';
import './status';
const $root = $protobuf.roots['square-experiments'] || ($protobuf.roots['square-experiments'] = new $protobuf.Root());
$root.addJSON({
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "experiments": {
                "nested": {
                  "message": {
                    "nested": {
                      "TrackEventRequest": {
                        "fields": {
                          "eventName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "userToken": {
                            "type": "squareup.feature.relay.common.Token",
                            "id": 2,
                            "rule": "optional"
                          },
                          "eventValues": {
                            "type": "squareup.feature.relay.common.Attribute",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "userAttributes": {
                            "type": "squareup.feature.relay.common.UserAttributes",
                            "id": 4,
                            "rule": "optional"
                          },
                          "cdpKey": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "projectId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "TrackEventResponse": {
                        "fields": {
                          "status": {
                            "type": "squareup.feature.relay.experiments.message.Status",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE TrackEventRequest @ squareup/feature/relay/experiments/message/track_event.proto at 14:1
 */
export const TrackEventRequest = $root.lookupType('squareup.feature.relay.experiments.message.TrackEventRequest');
fixType(TrackEventRequest, {
  eventName: {
    required: true,
    notEmpty: true
  },
  userToken: {
    required: true
  }
});
Builder.createAndAttachToType(TrackEventRequest);
/**
 * SOURCE TrackEventResponse @ squareup/feature/relay/experiments/message/track_event.proto at 29:1
 */
export const TrackEventResponse = $root.lookupType('squareup.feature.relay.experiments.message.TrackEventResponse');
fixType(TrackEventResponse);
Builder.createAndAttachToType(TrackEventResponse);